export enum BookingStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  REFUNDED = 'refunded',
  CANCELLED_CREDIT = 'cancelled_credit',
  CANCELLED_REFUND = 'cancelled_refund',
  CANCELLED_PASS = 'cancelled_pass',
  CANCELLED_BY_HOST = 'cancelled_by_host',
  TRANSFERRED = 'transferred',
}

export enum TransferStatus {
  PENDING = 'PENDING',
  PARTIAL = 'PARTIAL',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
}

export enum RefundMethod {
  STORE_CREDIT = 'STORE_CREDIT',
  STRIPE_REFUND = 'STRIPE_REFUND',
}

export enum StoreCreditTransactionType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
  ADMIN_CREDIT = 'ADMIN_CREDIT',
  ADMIN_DEBIT = 'ADMIN_DEBIT',
  GIFT_CARD_REDEMPTION = 'GIFT_CARD_REDEMPTION',
}

export enum PaymentStatus {
  PENDING = 'pending',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  REFUNDED = 'refunded',
}

export interface Booking {
  id: string;
  sessionId: string;
  userId: string;
  status: BookingStatus;
  totalAmount: number;
  stripePaymentIntentId?: string;
  storeCreditApplied?: number;
  refundMethod?: RefundMethod;
  stripeRefundAmount?: number;
  promotionCodeId?: string;
  promotionCodeSnapshot?: string;
  discountAmount: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface StoreCreditBalance {
  id: string;
  userId: string;
  balance: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface StoreCreditTransaction {
  id: string;
  userId: string;
  bookingId?: string;
  type: StoreCreditTransactionType;
  amount: number;
  description?: string;
  createdAt: Date;
}

export interface BookingParticipant {
  id: string;
  bookingId: string;
  profileId: string;
  profileType: 'kid' | 'adult';
  createdAt: Date;
}

export interface Payment {
  id: string;
  bookingId: string;
  stripeChargeId: string;
  amount: number;
  status: PaymentStatus;
  refundedAmount?: number;
  storeCreditUsed?: number;
  stripeAmount?: number;
  createdAt: Date;
  updatedAt: Date;
}

// Add these new types for API request payloads
export interface ParticipantKidInput {
  profileId?: string; // Optional: for direct profile linking
  name: string;
  birthDate: string;
  notes?: string;
}

export interface ParticipantAdultInput {
  profileId?: string; // Optional: for direct profile linking
  name: string;
  phone: string;
}

export interface ParticipantsInput {
  kids: ParticipantKidInput[];
  adults: ParticipantAdultInput[];
}
